<template>
    <div class="module_container" v-if="fields">
        <div class="module_shadow">
            <div class="module_header row no_wrap align_center justify_between">
                <div class="span_auto">
                    <h2>{{ fields.page_title }}</h2>
                </div>
            </div>
            <div class="module_copy row">
                <div class="span_12" v-html="markdown(fields.page_content)"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as contentful from 'contentful';
    import marked from 'marked';

    export default {
        data() {
            return {
                fields: null,
                content_client: null
            }
        },
        props: ['page'],
        created() {
            this.content_client = contentful.createClient({
                space: process.env.SPACE_ID,
                accessToken: process.env.CMS_TOKEN
            });

            this.fetch_data();
        },
        methods: {
            fetch_data() {
                this.content_client.getEntries({
                    content_type: 'dash_page',
                    'fields.slug': this.page
                }).then((response) => {
    				this.fields = response.items[0].fields;
    				console.log(response);
                }).catch(console.error);
            },
            markdown(string) {
				return marked(string);
			}
        },
        watch: {
            $route() {
                this.fetch_data();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// dash_page.vue?78d2b1d4